module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp3_9005.7ddbeb1b.png";